import type { Pole, PoleMotion } from "../../shared/gl";

/**
 * The cool gradient's tunables, from the prototype's config.js (FEATUREDWORK).
 * Its position never moves: no wander, no scroll swell (the prototype's
 * expandScale, expandRise and expandGain are all 0). The life is internal,
 * plus a local response to the pointer.
 */
export const FEATUREDWORK = {
    /** The canvas is the whole section and entirely soft */
    dprMax: 1,
    scale: 0.36,
    offsetX: 0.0,
    offsetY: 0.06,
    colorFalloff: 1.25,
    falloff: 1.15,
    edgeGain: 2.0,
    edgeShape: 2.3,
    shapeWarpAmp: 0.045,
    shapeWarpFreq: 0.5,
    shapeWarpSpeed: 0.02,
    colorWarpAmp: 0.08,
    colorWarpFreq: 0.46,
    colorWarpSpeed: 0.024,
    /** p-space y below which the field is solid */
    floorAt: -0.3,
    floorSoft: 0.505,
    curRadius: 0.62,
    curWarp: 0.085,
    curSat: 0.62,
    curHue: -14.0,
    curSpread: 0.22,
    curBlur: 0.45,
    /** Per-frame (60Hz) easing of the pointer field's position */
    curEase: 0.045,
    /** Per-frame (60Hz) easing of the pointer field's strength */
    curFade: 0.06,
    blurPx: 86,
    blurIterations: 3,
    blurBreath: 0.34,
    blurBreathPeriod: 84,
} as const;

export const FEATUREDWORK_MOTION: PoleMotion = {
    colorSpread: 1.0,
    paletteWash: 0,
    shapeDrift: 0.03,
    shapePeriodMul: 2.2,
    shapeRound: 0.96,
    orbitAmp: 0.15,
    orbitPeriod: 78,
    radiusBreath: 0.1,
    radiusBreathPeriod: 62,
    brightBreath: 0.05,
    satBreath: 0.06,
    breathPeriod: 56,
    hueBreath: 0.0,
    hueBreathPeriod: 74,
};

/** A ladder around the base, #0587c1, and two tints of it toward white */
export const FEATUREDWORK_POLES: readonly Pole[] = [
    { x: -0.66, y: -0.34, r: 0.34, color: "#64b5d9" },
    { x: -0.08, y: -0.22, r: 0.33, color: "#a0d1e7" },
    { x: 0.52, y: -0.06, r: 0.32, color: "#0587c1" },
    { x: -0.44, y: 0.18, r: 0.33, color: "#0587c1" },
    { x: 0.16, y: 0.34, r: 0.33, color: "#0587c1" },
    { x: 0.7, y: 0.3, r: 0.31, color: "#0587c1" },
];
